import { render } from "./records.vue?vue&type=template&id=633c91f8&scoped=true"
import script from "./records.vue?vue&type=script&lang=js"
export * from "./records.vue?vue&type=script&lang=js"

import "./records.vue?vue&type=style&index=0&id=633c91f8&scoped=true&lang=css"
import "./records.vue?vue&type=style&index=1&id=633c91f8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633c91f8"]])

export default __exports__